<template>
  <footer>
    <div class="footer-main flex-display flex-center-pack">
      <div class="main-left flex-display">
        <div class="logo-frame">
          <!-- 派加 -->
          <img
            v-if="webType === 0"
            class="logo"
            :src="`${$baseImgUrlTow}20220519/fd38719c-bf6a-4b4a-a15f-b36ff2f40822.png`"
            alt=""
          />
          <!-- 卡百利 -->
          <img
            v-else-if="webType === 1"
            class="logo"
            :src="`${$baseImgUrlTow}20220107/d49c817f-b69c-4e14-bc7a-12655f1e4532.png`"
            alt=""
          />
          
        </div>

        <div class="list-frame flex-display flex-row-between">
          <div
            class="list-item flex-display flex-display-column"
            v-for="(itemList, index) in navList"
            :key="index"
          >
            <span class="item-title">{{ itemList.title }}</span>
            <div class="line"></div>
            <ul class="item-list">
              <li
                class="pointer"
                v-for="(item, index) in itemList.list"
                :key="index"
              >
                {{ item.text }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="border-frame">
        <div class="border"></div>
      </div>
      <div class="main-right flex-display">
        <div class="phone-frame flex-display flex-display-column">
          <span class="title margin-b20">联系我们</span>
          <span class="text">191-5740-9539</span>
        </div>
        <div class="code-frame flex-display flex-display-column">
          <span class="title margin-b20">关注我们</span>
          <div class="img-frame flex-display">
            <div
              class="img-item flex-display flex-display-column flex-center-align"
            >
            <!-- 卡百利 -->
              <img
                v-if="webType === 0"
                :src="`https://cdn-oss.kabel.work/scheme/20220704/d6c45329-b26b-4ad2-b039-7e1374e4a223.jpg`"
                class="img"
                alt=""
              />
              <!-- 派加 -->
              <img
                v-else-if="webType === 1"
                :src="`https://cdn-oss.kabel.work/website/images/kabaili-code.png`"
                class="img"
                alt=""
              />

              <span class="text">{{webType === 0 ? '派加' : webType === 1 ? '卡百利' : ''}}服务通知</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom" >
      <a v-if="webType === 0" href="https://beian.miit.gov.cn/" >粤ICP备2021015608号 </a>
      <a v-else-if="webType === 1" href="https://beian.miit.gov.cn/" >粤ICP备18062693号 </a>
    </div>
  </footer>
</template>
<script>

export default {
  name: 'Footer',
  data () {
    return {
      shadowFlag: false,
      num: 0,
      navList: [
        // 暂时注释 { title: '交易保障', list: [{ text: '安全保障' }, { text: '交易验证' }, { text: '交易流程' }, { text: '交易赔付' }] },
        { title: '关于我们', list: [{ text: '加入我们' }, { text: '平台热点' }] }
        //  暂时注释{ title: '帮助中心', list: [{ text: '新手教程' }, { text: '意见反馈' }, { text: '常见问题' }, { text: '用户协议' }] }
      ],
      navActiveIndex: -1
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/common/footer.vue